import React from 'react'

import { Body2, Box, Display, FontWeight, Join, Link, Space } from '@gousto-internal/citrus-react'

import { useMarketingPricingConfig } from '@library/api-pricing'

export const terms = `Not including additional charges. Offer may only be claimed once and applies to the account you are logged into. Once discount is claimed, the relevant discount will be applied to your first order and subsequent discount to all following orders delivered within 60 days. This offer cannot be used in conjunction with other offers.`

interface Props {
  children: React.ReactNode
}

export const FooterNotice = ({ children }: Props) => {
  const existingPricing = {
    portionDescription: '5 x 4',
    pricePerPortion: '3.09',
    discountedPricePerPortion: '1.54',
  }

  const newPricing = useMarketingPricingConfig()

  const { portionDescription, pricePerPortion, discountedPricePerPortion } =
    newPricing || existingPricing

  return (
    <Box
      paddingH={[3, 8, 8, 8]}
      paddingV={0}
      paddingBottom={4}
      maxWidth={['100%', '60rem', '60rem', '60rem']}
      style={{ margin: 'auto' }}
    >
      <Join with={<Space size={2} />}>
        {children}

        <Body2>
          ** New customers only.{' '}
          <Box display={Display.Inline} style={{ fontWeight: FontWeight.Bold }}>
            <Link href="https://www.gousto.co.uk/terms-and-conditions">Standard T&Cs apply.</Link>
          </Box>
          {terms}
          <br />
        </Body2>

        <Body2>
          * Based on Gousto having more recipes, and more quick & easy recipes, available on the
          weekly menu than other recipe boxes delivering to the same regions in the UK as Gousto.
          The full details of this comparison can be found here:{' '}
          <Box display={Display.Inline} style={{ fontWeight: FontWeight.Bold }}>
            <Link href="https://cook.gousto.co.uk/choice/">verification of choice</Link>
          </Box>{' '}
          and our{' '}
          <Box display={Display.Inline} style={{ fontWeight: FontWeight.Bold }}>
            <Link href="https://cook.gousto.co.uk/more-quick-and-easy-recipes/">
              biggest ever menu.
            </Link>
          </Box>
        </Body2>

        <Body2>
          <sup>†</sup> Free Next Day Delivery is available for new customers who complete the
          sign-up and checkout process before 11:59am on Friday, Saturday, Monday, and Tuesday. Next
          Delivery availability is limited and so where capacity is reached, customers may see a
          later first delivery date available. Next day delivery is not available across all regions
          (including Northern Ireland) in the UK and is subject to geographical availability.
        </Body2>

        <Body2>
          <sup>‡</sup> £{pricePerPortion} Based on price per portion on a {portionDescription}{' '}
          subscription box. Excl. £3.99 delivery fee & surcharges. £{discountedPricePerPortion}{' '}
          based on new customer price per portion on a {portionDescription} subscription box. Excl.
          surcharges.
        </Body2>
      </Join>
    </Box>
  )
}
